<template>
  <div class="mt-10">
    <div class="mb-4">
      <h3 class="fsize32 text-primary font-semibold mb-2">Emotional Support</h3>
      <p class="fsize14">
        Caring for a loved one with cancer can be emotionally draining for both
        the patient and the caregiver. It's essential to understand the
        importance of emotional support for both parties during this time. In
        this blog, we will discuss the need for emotional support and ways to
        provide it.
      </p>
    </div>
    <div class="flex w-full gap-6">
      <div class="container">
        <div class="w-full mt-8">
          <h2 class="fsize20 text4F0A4B text-left mb-1 uppercase">
            Why <b>emotional support</b> is essential ?
          </h2>
          <p class="fsize14">
            Coping with the emotional impact of a cancer diagnosis: A cancer
            diagnosis can be a traumatic event, and both the patient and the
            caregiver may experience feelings of shock, fear, anger, and
            sadness. Emotional support can help both parties cope with these
            feelings and come to terms with the diagnosis. 
          </p>
        </div>

        <div class="my-8">
          <div class="w-full flex gap-4">
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Managing-side%20effects-of-treatment.jpg"
                alt="cancer"
                class="first_img1 object-cover"
              />

              <p class="fsize14 mt-3 text-center">
                Managing the side effects of treatment: The side effects of
                cancer treatment can be challenging to manage, and emotional
                support can help the patient and the caregiver navigate through
                these difficulties.
              </p>
            </div>
            <div class="w-1/2">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Reducing-stress%20and-anxiety.jpg"
                alt="cancer"
                class="second_img1 object-cover"
              />
              <p class="fsize14 mt-3 text-center">
                Reducing stress and anxiety: Caring for a loved one with cancer
                can be stressful and overwhelming. Emotional support can help
                reduce stress and anxiety levels, making it easier for both
                parties to cope with the challenges of cancer treatment.
              </p>
            </div>
          </div>
        </div>
        <div class="my-8">
          <div class="w-full">
            <h2 class="fsize20 text4F0A4B text-left mb-1 uppercase">
              Ways to provide <b>emotional support</b> ?
            </h2>
            <p class="fsize14">
              Coping with the emotional impact of a cancer diagnosis: A cancer
              diagnosis can be a traumatic event, and both the patient and the
              caregiver may experience feelings of shock, fear, anger, and
              sadness. Emotional support can help both parties cope with these
              feelings and come to terms with the diagnosis. 
            </p>
          </div>
          <div class="w-full grid grid-cols-4 gap-4 mt-8">
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Communication.jpg"
                alt="cancer"
                class="blog_img object-cover"
              />
              <p class="fsize13 mt-3 text-center">
                Communication: Communication is essential when providing
                emotional support. Encourage the patient to express their
                feelings and concerns and listen actively without judgment.
                Remember to also communicate your own feelings and concerns.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Seek-out-support-groups.jpg"
                alt="cancer"
                class="blog_img object-cover"
              />
              <p class="fsize13 mt-3 text-center">
                Seek out support groups: Support groups can provide a safe space
                for the patient and the caregiver to share their experiences
                with others who are going through similar situations.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Encourage%20self-care.jpg"
                alt="cancer"
                class="blog_img object-cover"
              />
              <p class="fsize13 mt-3 text-center">
                Encourage self-care: Encourage the patient and the caregiver to
                prioritize self-care activities, such as exercise, meditation,
                and hobbies, to help reduce stress levels.
              </p>
            </div>
            <div>
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/Seek-professional-help.jpg"
                alt="cancer"
                class="blog_img object-cover"
              />
              <p class="fsize13 mt-3 text-center">
                Seek professional help: It's important to seek professional help
                if either the patient or the caregiver is experiencing severe
                emotional distress. Professional counselors and therapists can
                provide additional support and guidance.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="w-1/6 border-left py-4 pl-4">
        <div class="border-bottom">
          <h2 class="fsize16 font-semibold pb-1">Our Latest Blogs</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            5 Essential Tips for Balancing Caregiving and Self-Care
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Navigating the Emotional Challenges of Being a...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            How to Create a Support Network for Caregivers
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Understanding the Legal Rights of Family Caregivers
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            10 Signs of Caregiver Burnout and How to Avoid It
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Latest Research</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            The Mental Health Impact of Caregiving on Family Members
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers Need ..
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            he Science Behind Compassion Fatigue: What...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Latest Research on the Emotional Toll of End-of-Life..
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers...
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Explore Resources</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Emotional First Aid</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Caregiver Coach Program</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Mental health Awareness</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Medical Terminology</p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">Caring at Caregiver sath</p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">
            Helpful Links and Collaborations
          </h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Duis volutpat pulvinar nisi
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            et rutrum nisl rhoncus nec
          </p>
        </div>
      </div>/// -->
      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
  </div>
</template>

<script>
import SideBlogs from "./components/SideBlogs.vue";

export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.first_img1 {
  height: 250px;
  width: 100%;
}
.second_img1 {
  height: 250px;
  width: 100%;
}
.blog_img {
  height: 155px;
  width: 100%;
}
</style>
